import React from 'react';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import './App.css';
import MainView from './MainView';
import ErrorComponent from './components/errorComponent/ErrorComponent';
import HomePage from './pages/home/HomePage';
import GameDetailPage from './pages/gameDetail/GameDetailPage';
import Subscribe from './pages/subscribe/Subscribe';
import Upgrade from './pages/subscribe/Upgrade';
import Profile from './pages/profile/Profile';
import GamesPage from './pages/games/GamesPage';
import Invoice from './pages/invoice/Invoice';
import PaymentHistoryComp from './pages/paymentHistory/PaymentHistory';
import GradePage from './pages/games/GradePage';
import Faq from './pages/faq/faq';
import Contact from './pages/contact/contact';
import Thanks from './pages/thanks/Thanks';
import Terms from './pages/terms/terms';
import Privacy from './pages/privacy/privacy';
import ProtectedRoutes from './components/protectedRoutes';
import LoginPage from './components/loginPage/loginPage';
import ToastMessage from './components/toastMessage/ToastMessage';

const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />
  },
  {
    element: (
      <ProtectedRoutes>
        <MainView />
      </ProtectedRoutes>
    ),
    children: [
      {
        path: "/",
        element: <HomePage />,
      },
      {
        path: "/subscribe",
        element: <Subscribe />,
      },
      {
        path: "/upgrade",
        element: <Upgrade />,
      },
      {
        path: "/game-detail/:gameId",
        element: <GameDetailPage />,
      },
      {
        path: "/profile",
        element: <Profile />,
      },
      {
        path: "/games/:gameType",
        element: <GamesPage />,
      },
      {
        path: "/grade/:gameType",
        element: <GradePage />,
      },
      {
        path: "/my-subscription/:orderid",
        element: <Invoice />,
      },
      {
        path: "/payment-history",
        element: <PaymentHistoryComp />,
      },
      {
        path: "/faq",
        element: <Faq />,
      },
      {
        path: "/contactUs",
        element: <Contact />,
      },
      {
        path: "/termsAndConditions",
        element: <Terms />,
      },
      {
        path: "/privacyPolicy",
        element: <Privacy />,
      },
      {
        path: "/thanks",
        element: <Thanks />,
      },
    ],
    errorElement: <ErrorComponent />,
  }
]);

function App() {
  return (
    <div className="App">
      <RouterProvider router={router} />
      <ToastMessage />
    </div>
  );
}

export default App;
